import axios from 'axios'
const state = {
    pauses: [],
    motivoPause: '',
    tempoFinal: '',
    tempoInicio: '',
    pause: false,
    pauseTimer: 'null'


}
const getters = {
    getPauses: state => state.pauses,
    getPause: state => state.pause,
    getTempoInicio: state => state.tempoInicio,
    getTempoFinal: state => state.tempoFinal,
    getMotivoPause: state => state.motivoPause,
    getPauseTime: state => state.pauseTimer,
}

const mutations = {
    allPauses: (state, pauses) => (state.pauses = pauses),
    setTempoInicio: (state, tempoInicio) => (state.tempoInicio = tempoInicio),
    setTempoFinal: (state, tempoFinal) => (state.tempoFinal = tempoFinal),

    setMotivoPause: (state, motivoPause) => (state.motivoPause = motivoPause),
    setQualAtemdimento: (state, qualAtendimento) => (state.qualAtendimento = qualAtendimento),
    setPause: (state, pause) => {
        state.pause = Boolean(pause);
    },
    setPauseTimer: (state, pause) => (state.pauseTimer = pause),
}

const actions = {
    async setPauseTime({ commit }, data) {
        commit('setPauseTimer', data);
    },
    async fetchPauses({ commit }) {
        const response = await axios('/pauses-list');
        commit('allPauses', response.data);
    },
    async fetchPausesSupervisor({ commit }) {
        const response = await axios('/pauses-list-supervisor');
        commit('allPauses', response.data);
    },
    async selectPause({ commit }, data) {
        commit('setPause', true);
        commit('setMotivoPause', data.pauseId);
        commit('setTempoInicio', data.tempo);
    },
    async comeBack({ commit }, data) {
        commit('setPause', false);
        commit('setMotivoPause', '');
        commit('setTempoFinal', data);
    },
    async sendPauseApi({ commit }, data) {
        await axios.post(`${location.origin}/api/setPause`, { userId: data.userId, pauseId: data.pauseId });
    },
    async sendUnpause({ commit }, data) {
        await axios.post(`${location.origin}/api/setPause`, { userId: data.userId, pauseId: 1 });
    },

    async sendOperatorPauseApiRealtime({ commit }, data) {
        // Suporta tanto array quanto string única
        const queues = Array.isArray(data.queues) ? data.queues : [data.queue];
        
        await axios.post(`${location.origin}/api/setOperatorPause`, {
            user_id: data.userId,
            pause_reason: data.pauseId,
            queues: queues, // Sempre envia como array
            pause_start: data.tempo
        });
    },

    async sendOperatorPauseApi({ commit }, data) {
        try {
            const resp = await axios.post(`${location.origin}/api/setOperatorPause`, {
                user_id: data.userId,
                pause_reason: data.pauseId,
                queues: data.queues,
                pause_start: data.tempo
            });
            return { success: true, data: resp.data };
        } catch (error) {
            if (error.response) {
                if (error.response.status === 422) {
                    const responseData = error.response.data;
                    
                    Swal.fire({
                        type: 'warning',
                        title: 'Limite de Pausas Atingido',
                        html: `
                            <div style="font-size: 15px; line-height: 1.6;">
                                <p style="margin-bottom: 15px;">Quantidade de pausas excedida para este período.</p>
                                <p style="color: #666;">Por favor, contate seu supervisor ou aguarde alguns instantes antes de tentar novamente.</p>
                            </div>
                        `,
                        confirmButtonText: 'Entendi',
                        confirmButtonColor: '#f39c12',
                        width: '550px',
                        padding: '2em'
                    });
                    
                    return { success: false, message: responseData.message };
                }
                
                const msg = (error.response.data && error.response.data.message) 
                    ? error.response.data.message 
                    : 'Erro no servidor';
                
                Swal.fire({
                    type: 'error',
                    title: 'Erro',
                    html: `<div style="font-size: 15px; line-height: 1.6;">${msg}</div>`,
                    confirmButtonText: 'OK',
                    width: '500px'
                });
                
                console.error('sendOperatorPauseApi error', error.response);
                return { success: false, message: msg };
            }
            
            Swal.fire({
                type: 'error',
                title: 'Erro de Conexão',
                text: 'Erro de comunicação. Tente novamente.',
                confirmButtonText: 'OK'
            });
            
            console.error('sendOperatorPauseApi network error', error);
            return { success: false, message: 'Erro de comunicação. Tente novamente.' };
        }
    },
    
    async sendOperatorUnpause({ commit }, data) {
        try {
            const payload = {
                user_id: data.userId, 
                pause_reason: 'retorno', 
                queues: data.queues || [data.queue], // Suporta array ou string
                pause_end: data.tempo 
            };

            // Usa o endpoint realtime para manter o mesmo fluxo de pause/unpause.
            const response = await axios.post(`${location.origin}/api/setOperatorPause`, payload);

            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error?.response?.data?.message || error?.message || 'Erro desconhecido',
                status: error?.response?.status,
                data: error?.response?.data
            };
        }
    }
}
export default {
    getters,
    mutations,
    actions,
    state
}
